import { getEasingFamily, getEasing, toKeyframeValue, INITIAL_FRAME_OFFSET } from '../../utils';
import { cssEasings as easings } from '../../easings';
export function getNames(_) {
  return ['motion-fadeIn', 'motion-punchIn'];
}
const TRANSLATION_FACTORS_MAP = {
  'top-left': {
    y: -1,
    x: -1
  },
  'top-right': {
    y: -1,
    x: 1
  },
  'bottom-right': {
    y: 1,
    x: 1
  },
  'bottom-left': {
    y: 1,
    x: -1
  },
  center: {
    y: 0,
    x: 0
  }
};
const POWER_MAP = {
  soft: 'sineIn',
  medium: 'quadIn',
  hard: 'quintIn'
};
function getMidPoint(x, y, factor) {
  return {
    x: `calc(var(--motion-width, 100%) * 1.1 / 3 * ${x} * ${factor})`,
    y: `calc(var(--motion-height, 100%) * 1.1 / 3 * ${y} * ${factor})`
  };
}
export function web(options, dom) {
  prepare(options, dom);
  return style(options, true);
}
export function style(options, asWeb) {
  if (asWeb === void 0) {
    asWeb = false;
  }
  const {
    direction = 'top-right',
    power = 'medium'
  } = options.namedEffect;
  const [fadeIn, punchIn] = getNames(options);
  const translationFactors = TRANSLATION_FACTORS_MAP[direction];
  const sourcePoint = {
    x: `calc(var(--motion-width, 100%) * 1.1 / 2 * ${translationFactors.x})`,
    y: `calc(var(--motion-height, 100%) * 1.1 / 2 * ${translationFactors.y})`
  };
  const {
    in: _in,
    out: _out
  } = getEasingFamily(POWER_MAP[power]);
  const KEYFRAMES = [{
    offset: 30,
    scale: 0.3,
    factor: 1,
    ease: 'linear'
  }, {
    offset: 45,
    scale: 1.4,
    factor: -0.4,
    ease: _out
  }, {
    offset: 62.65,
    scale: 0.8,
    factor: 0.2,
    ease: _in
  }, {
    offset: 77.27,
    scale: 1.1,
    factor: -0.1,
    ease: _out
  }, {
    offset: 86.23,
    scale: 0.94,
    factor: 0.06,
    ease: _in
  }, {
    offset: 91.73,
    scale: 1.03,
    factor: -0.03,
    ease: _out
  }, {
    offset: 95.11,
    scale: 0.98,
    factor: 0.02,
    ease: _in
  }, {
    offset: 97.18,
    scale: 1.01,
    factor: -0.01,
    ease: _out
  }, {
    offset: 98.45,
    scale: 0.99,
    factor: 0.01,
    ease: _in
  }, {
    offset: 100,
    scale: 1,
    factor: 0,
    ease: _out
  }];
  const keyframes = KEYFRAMES.map(_ref => {
    let {
      offset,
      scale,
      ease,
      factor
    } = _ref;
    const {
      x,
      y
    } = getMidPoint(translationFactors.x, translationFactors.y, factor);
    return {
      offset: offset / 100,
      easing: getEasing(ease),
      scale: `${scale}`,
      translate: `${x} ${y}`
    };
  });
  const custom = {
    '--motion-translate': `${sourcePoint.x} ${sourcePoint.y}`
  };
  return [{
    ...options,
    easing: 'cubicIn',
    duration: options.duration * 0.3,
    name: fadeIn,
    custom: {},
    keyframes: [{
      offset: 0,
      opacity: 0
    }, {
      opacity: 'var(--comp-opacity, 1)'
    }]
  }, {
    ...options,
    easing: 'linear',
    name: punchIn,
    custom,
    keyframes: [{
      offset: INITIAL_FRAME_OFFSET,
      translate: toKeyframeValue(custom, '--motion-translate', asWeb),
      scale: '0',
      easing: easings.expoIn
    }, ...keyframes]
  }];
}
export function prepare(_, dom) {
  if (dom) {
    let width, height;
    dom.measure(target => {
      if (!target) {
        return;
      }
      const rect = target.getBoundingClientRect();
      width = rect.width;
      height = rect.height;
    });
    dom.mutate(target => {
      target == null || target.style.setProperty('--motion-width', `${width}px`);
      target == null || target.style.setProperty('--motion-height', `${height}px`);
    });
  }
}
//# sourceMappingURL=PunchIn.js.map